import Breadcrumbs from "../../../components/breadcrumbs";
import PhysicalAndMentalSymptomCreateForm from "./ui/physical-and-mental-symptom-create-form";

export default function PhysicalAndMentalSymptomCreatePage() {
  return (
    <main className="max-w-3xl ">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Physical & Mental Symptoms", href: "/admin/physical-and-mental-symptoms" },
          {
            label: "Create",
            href: `/admin/physical-and-mental-symptoms/Create`,
            active: true,
          },
        ]}
      />

      <PhysicalAndMentalSymptomCreateForm />      
    </main>
  );
}
